var eventbus = require('./src/eventbus');
var mapwms = require('./src/mapwms');
var amapwms = require('./src/amapwms');
var tmapwms = require('./src/tmapwms');
module.exports = {
    eventbus: eventbus.default,
    mapwms: mapwms.default,
    amapwms: amapwms.default,
    tmapwms: tmapwms.default
}